import Vue from 'vue'
import Router from 'vue-router'
import { Toast } from 'vant'
import AdminSet from '@/pages/admin/set/index'
import AdminLogin from '@/pages/admin/login/index'
import AdminIndex from '@/pages/admin/index/index'
import AdminMerch from '@/pages/admin/merch/index'
import AdminMerchPost from '@/pages/admin/merch/post'
import AdminSpec from '@/pages/admin/spec/index'
import AdminSpecPost from '@/pages/admin/spec/post'
import AdminOrderList from '@/pages/admin/order/index'
import AdminOrderDetail from '@/pages/admin/order/detail'
import AdminOrderSummary from '@/pages/admin/order/summary'
import AdminOrderSum from '@/pages/admin/order/totalSum'
import AdminOrderEdit from '@/pages/admin/order/edit'
import AdminOrderChild from '@/pages/admin/order/childorder'
import AdminOrderPrint from '@/pages/admin/order/print'
import AdminOrderSumPrint from '@/pages/admin/order/sumprint'

import HomeIndex from '@/pages/home/index/index'
import HomeLogin from '@/pages/home/login/index'
import HomeSet from '@/pages/home/set/index'
import HomeOrderAdd from '@/pages/home/order/add'
import HomeOrderList from '@/pages/home/order/index'
import HomeOrderDetail from '@/pages/home/order/detail'
import HomeOrderEdit from '@/pages/home/order/edit'
import HomeOrderSummary from '@/pages/home/order/summary'
Vue.use(Router).use(Toast)
const routes = [
  {
    path: '/',
    redirect: '/home/index'
  },
  {
    path: '/home',
    redirect: '/home/index'
  },
  {
    path: '/admin/index',
    meta: {
      requireAuth: true,
      keepAlive: false
    },
    component: AdminIndex
  },
  {
    path: '/admin/set',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: AdminSet
  },
  {
    path: '/admin/login',
    component: AdminLogin,
    meta: {
      requireAuth: false,
      keepAlive: false
    },
  },
  {
    path: '/admin/merch',
    component: AdminMerch,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/admin/merch/post',
    children: [{
      path: '/admin/merch/post/:id',
      component: AdminMerchPost
    }],
    component: AdminMerchPost,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/admin/spec',
    component: AdminSpec,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/admin/spec/post',
    children: [{
      path: '/admin/spec/post/:id',
      component: AdminMerchPost
    }],
    component: AdminSpecPost,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/admin/order/list',
    component: AdminOrderList,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/admin/order/detail/:id',
    component: AdminOrderDetail,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },
  {
    path: '/admin/order/summary/:id',
    component: AdminOrderSummary,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },
  {
    path: '/admin/order/sum',
    component: AdminOrderSum,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },
  {
    path: '/admin/order/edit/:id',
    component: AdminOrderEdit,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },
  {
    path: '/admin/order/childorder/:id',
    component: AdminOrderChild,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/admin/order/print/:parentid',
    component: AdminOrderPrint,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },
  {
    path: '/admin/order/sumprint',
    component: AdminOrderSumPrint,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },
  {
    path: '/home/index',
    component: HomeIndex,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },
  {
    path: '/home/login',
    component: HomeLogin,
    meta: {
      // requireAuth: false,
      keepAlive: false
    }
  },
  {
    path: '/home/set',
    component: HomeSet,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/home/order/add',
    component: HomeOrderAdd,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/home/order/sum',
    component: HomeOrderSummary,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },

  {
    path: '/home/order/list',
    component: HomeOrderList,
    meta: {
      requireAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/home/order/detail/:id',
    component: HomeOrderDetail,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },
  {
    path: '/home/order/edit/:id',
    component: HomeOrderEdit,
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  },
  {
    path: '/about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  }
]

import { LoginModel } from "@models/home/login";

const loginModel = new LoginModel()

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  if (localStorage.user_token && to.path.indexOf('/home') == 0) {
    loginModel.RemoteLogin({
      user_token: localStorage.user_token
    }).then(res => {
      if (res.data.isremotelogin == 1) {  //异步登录退出登录
        localStorage.removeItem("id");
        localStorage.removeItem("username");
        localStorage.removeItem("user_token");
        localStorage.removeItem("role");
        Toast('请先登录');
        next({
          path: '/home/login'
        })
      }
    })
  }

  if (to.matched.some(r => r.meta.requireAuth)) {
    if (to.path.indexOf('/home') != -1) {   //跳到前台登录
      if (localStorage.user_token && localStorage.role == 'merch') {
        next();
      } else {
        Toast('请先登录');
        next({
          path: '/home/login',
          query: { redirect: to.fullPath }
        })
      }

    } else {  //跳到后台登录
      if (localStorage.user_token && localStorage.role == 'admin') {
        next();
      } else {
        Toast('请先登录');
        next({
          path: '/admin/login',
          query: { redirect: to.fullPath }
        })
      }
    }


  }
  else {
    next();
  }
})

export default router